export const WFP_ROUTES = {
  LOGIN: '/login',
  LOGOUT: '/logoutidp',
  STATEMENT: '/accessibilitystatement',
  SESSION: '/session',
  REQUEST: (id: string | number) => `/session/request/${id}`,
  DYNAMIC_FORM: (id: string | number) => `/session/form/${id}/dynamic`,
  STATIC_FORM: (id: string | number) => `/session/form/${id}/static`
};

export const WFP_PATHS = {
  REQUEST: 'request',
  FORM: 'form',
  DYNAMIC: 'dynamic',
  STATIC: 'static',
  LOGIN: 'login',
  LOGOUT: 'logoutidp',
  SESSION: 'session',
  STATEMENT: 'accessibilitystatement'
};
